import React from "react"
import { Box, useTheme } from "@mallardbay/lib-react-components"

import {
    TextMedium,
    TextSmall,
} from "~components/shared/todo-lib-react-components/text"
import { LargeGrayCheckbox } from "~components/shared/todo-lib-react-components/inputs/checkbox"

interface Props {
    readonly label: string
    readonly isChecked: boolean
    readonly onChange: (value: boolean) => void
    readonly helpText?: string
}

export default function FilterCheckbox({
    label,
    isChecked,
    onChange,
    helpText,
}: Props) {
    const styles = useStyles()

    return (
        <Box style={styles.container}>
            <LargeGrayCheckbox
                isChecked={isChecked}
                onChange={(newIsChecked) => onChange(newIsChecked)}
                style={styles.checkbox}
            >
                <Box style={styles.labelContainer}>
                    <TextMedium style={styles.label}>{label}</TextMedium>
                    {helpText && (
                        <TextSmall style={styles.helpText}>
                            {helpText}
                        </TextSmall>
                    )}
                </Box>
            </LargeGrayCheckbox>
        </Box>
    )
}

function useStyles() {
    const { colors } = useTheme()

    return {
        container: {
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: "5px",
        },
        labelContainer: {
            display: "flex",
            flexDirection: "column",
        },
        label: {
            marginTop: "2px",
            marginBottom: 0,
        },
        helpText: {
            color: colors.contentTertiary,
            marginTop: 0,
            marginBottom: 0,
        },
        checkbox: {
            marginY: "12px",
        },
    }
}
